import { PropsWithChildren } from 'react';

import { Container } from '@/components/Container';

export const OrderShell = ({ children }: PropsWithChildren) => {
  return (
    <Container
      debugColor={'black'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        padding: '16px',
        borderTop: '1px solid #c3c3c3',
      }}
    >
      {children}
    </Container>
  );
};
